import client from '../client';
import endpoints from '../endpoints';

/**
 * 스케줄/휴무일/버퍼 — 관리자 API
 * API_DOCS: 18. 관리자 - 스케줄
 */

export const getCalendar = async (params = {}) => {
  const res = await client.get(endpoints.admin.schedule.calendar, { params });
  return res.data;
};

export const createBlock = async (data) => {
  const res = await client.post(endpoints.admin.schedule.block, data);
  return res.data;
};

export const deleteBlock = async (id) => {
  const res = await client.delete(endpoints.admin.schedule.blockDelete(id));
  return res.data;
};

export const getHolidays = async () => {
  const res = await client.get(endpoints.admin.holidays.list);
  return res.data;
};

export const createHoliday = async (data) => {
  const res = await client.post(endpoints.admin.holidays.list, data);
  return res.data;
};

export const updateHoliday = async (id, data) => {
  const res = await client.put(endpoints.admin.holidays.detail(id), data);
  return res.data;
};

export const deleteHoliday = async (id) => {
  const res = await client.delete(endpoints.admin.holidays.detail(id));
  return res.data;
};

export const getBuffer = async () => {
  const res = await client.get(endpoints.admin.buffer);
  return res.data;
};

export const updateBuffer = async (data) => {
  const res = await client.put(endpoints.admin.buffer, data);
  return res.data;
};
